/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/* global window */

export function rwdButton() {

	// handle mobile menu button
	const rwdButton = document.querySelector( '.header__main-rwd-button a' );
	const rwdTop = document.querySelector( '.top' );

	rwdButton.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		rwdTop.classList.toggle( 'rwd-menu-active' );
	} );
}
